import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivateMembershipComponent } from './activate-membership/activate-membership.component';
import { ConsultDoctorComponent } from './consult-doctor/consult-doctor.component';
import { DoctorReportsComponent } from './doctor-reports/doctor-reports.component';
import { MailviewComponent } from './mailview/mailview.component';
import { MessagecenterComponent } from './messagecenter/messagecenter.component';
import { PatientDashboardComponent } from './patient-dashboard/patient-dashboard.component';
import { PatientworkflowComponent } from './patientworkflow/patientworkflow.component';
import { PcomposeEmailComponent } from './pcompose-email/pcompose-email.component';
import { AppBreadcrumbComponent } from './shared/app.breadcrumb.component';
import { AppMenuComponent } from './shared/app.menu.component';
import { AppMenuitemComponent } from './shared/app.menuitem.component';
import { AppTopBarComponent } from './shared/app.topbar.component';
import { TrackRequestComponent } from './track-request/track-request.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { UploadAndEditDocumentsComponent } from './upload-and-edit-documents/upload-and-edit-documents.component';
import { ViewhealthComponent } from './viewhealth/viewhealth.component';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { PatientRoutingModule } from './patient-routing.module';
import { SharedModule } from '../shared/shared.module';
import { InvoiceModule } from '../shared/invoice/invoice.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from '../../services/shared/auth-interceptor.service';
import { PatientViewModule } from '../shared/patient-view/patient-view.module';
import { UtilitiesModule } from '../shared/utilities/utilities.module';
import { VideoSectionComponent } from './video-section/video-section.component';
import { CouponListComponent } from './coupon-list/coupon-list.component';
import { PackagesComponent } from './packages/packages.component';
import { ActivatedMembersComponent } from './activated-members/activated-members.component';
import { HomeNovspecialComponent } from './home-novspecial/home-novspecial.component';
import { DietSectionComponent } from './diet-section/diet-section.component';
import { EditDataComponent } from './edit-data/edit-data.component';
import { HealthPassportComponent } from './health-passport/health-passport.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { MembershipPlanComponent } from './membership-plan/membership-plan.component';
import { PaymentStatusComponent } from './payment-status/payment-status.component';


@NgModule({
    declarations: [
        AppMenuComponent,
        AppMenuitemComponent,
        AppTopBarComponent,
        AppBreadcrumbComponent,
        PatientworkflowComponent,
        ActivateMembershipComponent,
        PatientDashboardComponent,
        TrackRequestComponent,
        UploadAndEditDocumentsComponent,
        TransactionsComponent,
        ViewhealthComponent,
        ConsultDoctorComponent,
        MessagecenterComponent,
        MailviewComponent,
        PcomposeEmailComponent,
        DoctorReportsComponent,
        CouponListComponent,
        PackagesComponent,
        ActivatedMembersComponent,
        VideoSectionComponent,
        HomeNovspecialComponent,
        DietSectionComponent,
        EditDataComponent,
        HealthPassportComponent,
        MembershipPlanComponent,
        PaymentStatusComponent,
       

    ],
    imports: [
        PrimengModule,
        PatientRoutingModule,
        SharedModule,
        InvoiceModule,
        HttpClientModule,
        PatientViewModule,
        UtilitiesModule,
        ProgressBarModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        }
    ],
})
export class PatientModule { }